import React, { useState, useRef, useEffect } from "react";
import Header from "../Header/Header";
import Asidebar from "../Header/Asidebar";
import { InfinitySpin } from "react-loader-spinner";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { getData, putData } from "../../FetchNodeServices";
import AlertMessages from "../Mains/Alerts";

const EditQuestions = () => {
  const [isActivated, setIsActivated] = useState(true);
  const [fullwidthwrapper, setFullwidthwrapper] = useState();
  const [isVisible, setIsVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [questionList, setQuestionList] = useState([]);
  const [questionTypeId, setQuestionTypeId] = React.useState("");
  const [questionType, setQuestionType] = useState([]);
  const [question, setQuestion] = useState("");
  const [questionTitle, setQuestionTitle] = useState("");
  const [questionCode, setQuestionCode] = useState("");
  const [status, setStatus] = useState("");
  const [answer, setAnswer] = useState("");
  const [answerCode, setAnswerCode] = useState("a1");
  const [answerSets, setAnswerSets] = useState([{ answerCode: "a1", answer: "", status: 1 }]);
  const [bulkAnswers, setBulkAnswers] = useState("");
  const [bulkAnswerCounter, setBulkAnswerCounter] = useState(1);
  const [singleAnswerCounter, setSingleAnswerCounter] = useState(1);
  const location = useLocation();
  const navigate = useNavigate();
  const [draggingItem, setDraggingItem] = useState(null);
  const [removedAnswerSets, setRemovedAnswerSets] = useState([]);
  const [alerts, setAlerts] = useState([]);

  const { search } = location;
  const queryParams = new URLSearchParams(search);
  const questionId = queryParams.get("questionId");

  const handleDragStart = (e, item) => {
    setDraggingItem(item);
  };

  const handleDragEnd = () => {
    setDraggingItem(null);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, targetIndex) => {
    if (!draggingItem || draggingItem === targetIndex) return;

    const updatedAnswerSets = [...answerSets];
    const draggingIndex = updatedAnswerSets.indexOf(draggingItem);
    const targetItem = updatedAnswerSets[targetIndex];

    // Remove draggingItem from its current position
    updatedAnswerSets.splice(draggingIndex, 1);

    // Insert draggingItem at the targetIndex
    updatedAnswerSets.splice(targetIndex, 0, draggingItem);

    // Update the state with the new order of answerSets
    setAnswerSets(updatedAnswerSets);

    // Update the sequence in the backend
    // updateSequence(questionId, draggingItem.answerId, targetIndex + 1);
    console.log(questionId, draggingItem.answerId, targetIndex);

    // Clear draggingItem
    setDraggingItem(null);
  };

  const updateSequence = async (questionId, answerId, ansOrder) => {
    try {
      await putData(`/users/drag-drop-question-answer/${questionId}/${answerId}/${ansOrder}`);
      console.log(`Answer ${answerId} sequence updated to ${ansOrder} for question ${questionId}`);
    } catch (error) {
      console.error(`Failed to update sequence for answer ${answerId} of question ${questionId}:`, error);
    }
  };

  const handleToggle = () => {
    setIsActivated(!isActivated);
    setFullwidthwrapper(isActivated ? "fullwrapper" : "");
  };

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  // const fetchHighestQuestionCode = async () => {
  //   try {
  //     const result = await getData("users/question-list");
  //     if (result && result.length > 0) {
  //       setQuestionList(result);

  //       // Initialize a variable to keep track of the highest numeric question code
  //       let highestNumber = 0;

  //       // Iterate over the question codes to find the highest number
  //       result.forEach((item) => {
  //         const match = item.questionCode.match(/^q(\d+)$/);
  //         if (match) {
  //           const number = parseInt(match[1], 10);
  //           if (number > highestNumber) {
  //             highestNumber = number;
  //           }
  //         }
  //       });

  //       // Increment the highest number to get the next question code
  //       const nextNumber = highestNumber + 1;
  //       const nextQuestionCode = `q${nextNumber}`;

  //       // Set the next question code in the component state
  //       setQuestionCode(nextQuestionCode);
  //     } else {
  //       // If the array is empty, set a default starting question code
  //       setQuestionCode("q1");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching question codes:", error);
  //   }
  // };

  // useEffect(() => {
  //   fetchHighestQuestionCode();
  // }, []);

  const fetchQuestionType = async () => {
    let result = await getData("users/question-types");
    setQuestionType(result);
  };
  useEffect(function () {
    fetchQuestionType();
  }, []);

  const fillQuestionType = () => {
    return questionType.map((item) => {
      return (
        <option key={item.genericValueId} value={item.genericValueId}>
          {item.genericValue}
        </option>
      );
    });
  };

  const handleUniqueCode = () => {
    return questionList.some((question) => question.questionCode === questionCode);
  };

  // const handleCopy = (inputElementRef) => {
  //   if (inputElementRef.current) {
  //     const textToCopy = inputElementRef.current.value;
  //     navigator.clipboard
  //       .writeText(textToCopy)
  //       .then(() => {
  //         console.log("Text copied to clipboard");
  //         setIscopied(true);
  //         setTimeout(() => {
  //           setIscopied(false);
  //         }, 2000);
  //       })
  //       .catch((err) => {
  //         console.error("Error copying text: ", err);
  //       });
  //   } else {
  //     console.error("Input element not found");
  //   }
  // };

  const handleUniqueAnswerCode = (answerSets) => {
    const answerCodeSet = new Set();
    for (const answerSet of answerSets) {
      if (answerCodeSet.has(answerSet.answerCode)) {
        return false;
      }
      answerCodeSet.add(answerSet.answerCode);
    }
    return true;
  };

  const addBulkAnswers = () => {
    const slicedAnswers = bulkAnswers.split("\n").filter((answer) => answer.trim() !== "");
    const newAnswerSets = slicedAnswers.map((answer, index) => ({
      answerCode: `a${(answerSets.length) + index + 1}`,
      answer: answer.trim(),
    }));
    const combinedAnswerSets = [...answerSets, ...newAnswerSets];
    if (!handleUniqueAnswerCode(combinedAnswerSets)) {
      setAlerts([{ variant: "danger", heading: "Duplicate answer codes found. Please ensure all answer codes are unique." }]);
      return;
    }

    setAnswerSets(combinedAnswerSets);
    setBulkAnswerCounter((prevCounter) => prevCounter + slicedAnswers.length);
    setAnswerCode(`a${combinedAnswerSets.length + 1}`);
    setAnswer(slicedAnswers[slicedAnswers.length - 1].trim());
    setBulkAnswers("");
    setIsVisible(!isVisible);
  };

  const addAnswerSet = () => {
    const newAnswerCode = `a${(answerSets.length) + 1}`;
    const newAnswerSets = [...answerSets, { answerCode: newAnswerCode, answer: "" }];
    if (!handleUniqueAnswerCode(newAnswerSets)) {
      setAlerts([{ variant: "danger", heading: "Duplicate answer codes found. Please ensure all answer codes are unique." }]);
      return;
    }

    setAnswerSets(newAnswerSets);
    setSingleAnswerCounter((prevCounter) => prevCounter + 1);
    setAnswerCode(newAnswerCode);
  };
  const removeAnswerSet = (index) => {
    const updatedAnswerSets = [...answerSets];
    const removedAnswerSet = updatedAnswerSets.splice(index, 1)[0];
    removedAnswerSet.status = 0;
    setRemovedAnswerSets((prevRemovedAnswerSets) => [...prevRemovedAnswerSets, removedAnswerSet]);
    setAnswerSets(updatedAnswerSets);

    const remainingAnswerSets = updatedAnswerSets.slice(index);
    const adjustedAnswerSets = remainingAnswerSets.map((answerSet, idx) => ({
      ...answerSet,
      answerCode: `a${index + 1 + idx}`,
    }));
    const newAnswerSets = [...updatedAnswerSets.slice(0, index), ...adjustedAnswerSets];
    setAnswerSets(newAnswerSets);

    if (newAnswerSets.length === 0) {
      setAnswerCode("a1");
      setSingleAnswerCounter(1);
      setBulkAnswerCounter(1);
      setAnswerSets([{ answerCode: "a1", answer: "" }]);
    } else {
      setAnswerCode(`a${newAnswerSets.length + 1}`);
    }
  };

  const handleAnswerCodeChange = (index, value) => {
    const updatedAnswerSets = [...answerSets];
    updatedAnswerSets[index].answerCode = value;
    if (!handleUniqueAnswerCode(updatedAnswerSets)) {
      setAlerts([{ variant: "danger", heading: "Duplicate answer codes found. Please ensure all answer codes are unique." }]);
      return;
    }

    setAnswerSets(updatedAnswerSets);
  };

  const handleAnswerChange = (index, value) => {
    const updatedAnswerSets = [...answerSets];
    updatedAnswerSets[index].answer = value;
    setAnswerSets(updatedAnswerSets);
  };

  const renderAnswerSets = () => {
    return answerSets.map((answerSet, index) => (
      <div
        className="row"
        key={index}
        draggable
        onDragStart={(e) => handleDragStart(e, answerSet)}
        onDragEnd={handleDragEnd}
        onDragOver={handleDragOver}
        onDrop={(e) => handleDrop(e, answerSet)}
      >
        <div className="col-lg-2 copy-text">
          {/* <label htmlFor="">Answer code</label> */}
          {/* <div className={`form-group mb-4 d-flex gap-2 align-items-center copy-text ${iscopied ? "active" : ""}`}> */}
          <input
            type="text"
            className="form-control "
            placeholder="231"
            value={answerSet.answerCode}
            onChange={(e) => handleAnswerCodeChange(index, e.target.value)}
          />
          {/* <button onClick={() => handleCopy(answerCodeRef)}>
              <i className="bi bi-copy">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-copy" viewBox="0 0 16 16">
              <path
              fillRule="evenodd"
              d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"
              />
              </svg>
              </i>
            </button> */}
          {/* </div> */}
        </div>
        <div className="col-lg-4">
          <div className="form-group mb-4">
            {/* <label htmlFor="">Answer statement</label> */}
            <input
              type="text"
              className="form-control"
              placeholder="Answer option"
              value={answerSet.answer}
              onChange={(e) => handleAnswerChange(index, e.target.value)}
            />
          </div>
        </div>
        <div className="col-lg-2">
          <i class="bi bi-x-circle fs-28" onClick={() => removeAnswerSet(index)}></i>
          {/* <button className="btn btn-danger" onClick={() => removeAnswerSet(index)}>
            Remove
          </button> */}
        </div>
      </div>
    ));
  };

  useEffect(() => {
    const fetchQuestionData = async () => {
      if (questionId) {
        const result = await getData(`users/question/${questionId}`);
        if (result) {
          setQuestionTypeId(result.questionType);
          setQuestion(result.question);
          setQuestionTitle(result.questionTitle);
          setQuestionCode(result.questionCode);
          setStatus(result.questionStatus);
          setAnswerSets(result.answerList);
          console.log("test:", result);
          setIsLoading(false);
        }
      }
    };

    fetchQuestionData();
  }, [questionId]);

  const handleSubmit = async () => {
    if (questionTitle === "" || question === "" || questionTypeId === "") {
      setAlerts([{ variant: "danger", heading: "Please fill all the mandatory fields." }]);
      return;
    }
    if (handleUniqueCode()) {
      setAlerts([{ variant: "danger", heading: "Question Code is already taken. Please use a different code." }]);
      return;
    }

    if (!handleUniqueAnswerCode(answerSets)) {
      setAlerts([{ variant: "danger", heading: "Duplicate answer codes found. Please ensure all answer codes are unique." }]);
      return;
    }

    const answersList = [...answerSets, ...removedAnswerSets].map((answerSet) => ({
      answerCode: answerSet.answerCode,
      answer: answerSet.answer,
      questionAnswerId: answerSet.questionAnswerId,
      status: answerSet.status,
    }));

    console.log("test", answersList);
    setIsLoading(true);
    var formData = {
      questionType: questionTypeId,
      questionCode: questionCode,
      question: question,
      questionStatus: status,
      questionTitle: questionTitle,
      answerList: answersList,
      questionId: questionId,
      //  answerSets.map((answerSet) => ({
      //   answerCode: answerSet.answerCode,
      //   answer: answerSet.answer,
      // })),
    };
    try {
      const response = await putData("users/update-question", formData);
      if (response) {
        setAlerts([{ variant: "success", heading: "Question updated successfully." }]);
        setTimeout(() => navigate("/profiling-questions"), 3000);
        // handleClear();
        // console.log(formData);
      } else {
        setAlerts([{ variant: "danger", heading: "Error updating question. Please try again later." }]);
      }
    } catch (error) {
      // console.error("Error submitting question:", error);
      setAlerts([{ variant: "danger", heading: "Error updating question. Please try again later." }]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClear = () => {
    // setQuestionTypeId("");
    // setQuestionCode("");
    // setQuestion("");
    // setQuestionTitle("");
    // setAnswerSets([{ answerCode: "a1", answer: "" }]);
    // setAnswer("");
    // setAnswerCode("a1");
    // setBulkAnswers("");
    // setIsVisible(false);
    // fetchHighestQuestionCode();
  };



  return (
    <div>
      <Asidebar isActivated={isActivated} />
      <div id="wrapper" className={fullwidthwrapper}>
        <Header onclick={handleToggle} />
        {isLoading && (
          <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center " style={{ zIndex: 1050 }}>
            <div className="p-5 rounded ">
              <InfinitySpin visible={true} width="200" color="#4fa94d" ariaLabel="infinity-spin-loading" />
            </div>
          </div>
        )}
        <div id="page_wrapper" className="py-3">
          <div className="card p-3 border-light-subtle mb-3">
            <ul className="breadcrumb m-0">
              <li>
                <Link to="/dashboard">
                  <i className="bi bi-people"></i> Dashboard
                </Link>
              </li>
              <li>
                <span className="breadcrumb_slash">/</span> <i className="bi bi-app-indicator mx-2"></i> Edit questions
              </li>
            </ul>
            <div className="position-absolute top-0 start-0 w-100 h-100" style={{ zIndex: 1050 }}>
              <AlertMessages alerts={alerts} setAlerts={setAlerts} />
            </div>
          </div>

          <div className="card p-3 border-light-subtle">
            <div className="common_form p-3">
              <div className="row">
                <div className="col-lg-2">
                  <div className="form-group mb-4 ">
                    <label for="">Question type</label>
                    <select
                      className=" form-select form-select-sm mb-3"
                      value={questionTypeId}
                      aria-label=".form-select-sm"
                      onChange={(event) => setQuestionTypeId(event.target.value)}
                    >
                      <option value="">Select Question Type</option>
                      {fillQuestionType()}
                      {/* <option value="1">Multi-select</option>
                      <option value="2">One-line text</option>
                      <option value="3">Dropdown</option>
                      <option value="4">Single-Select</option> */}
                    </select>
                  </div>
                </div>
                <div className="col-lg-4 form-check form-switch">
                  <label className="form-check-label" htmlFor="statusSwitch">
                    Status
                  </label>
                  <input
                    className="form-check-input ms-2"
                    type="checkbox"
                    role="switch"
                    id="statusSwitch"
                    checked={status === 1} // assuming 1 is the value for active status
                    onChange={(e) => setStatus(e.target.checked ? 1 : 0)}
                  />
                </div>

                <div className="row">
                  <div className="col-lg-2">
                    <label for="">Question code</label>
                    {/* <div className={`form-group mb-4 d-flex gap-2 align-items-center copy-text ${iscopied ? "active" : ""}`}> */}
                    <input
                      type="text"
                      // className="form-control bg-transparent border-0 shadow-none"
                      className="form-control "
                      value={questionCode}
                      // ref={questionCodeRef}
                      placeholder="456321"
                      onChange={(event) => setQuestionCode(event.target.value)}
                    />
                    {/* <button onClick={() => handleCopy(questionCodeRef)}>
                        <i className="bi bi-copy">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-copy" viewBox="0 0 16 16">
                            <path
                              fillRule="evenodd"
                              d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"
                            />
                          </svg>
                        </i>
                      </button> */}
                    {/* </div> */}
                  </div>

                  <div className="col-lg-2">
                    <div className="form-group mb-4">
                      <label for="">Question Title</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Question Title"
                        value={questionTitle}
                        onChange={(event) => setQuestionTitle(event.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="form-group mb-4">
                      <label for="">Question statment</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="The question that will be display to user"
                        value={question}
                        onChange={(event) => setQuestion(event.target.value)}
                      />
                    </div>
                  </div>
                </div>
                {questionTypeId == 15 || questionTypeId == 16 ? "" : (<div className="row">
                  <div className="col-lg-4">
                    <div className="form-group mb-4">
                      <label htmlForr="">
                        Add answers in bulk
                        <span className="mx-4" onClick={toggleVisibility}>
                          {isVisible ? <i className="bi bi-toggle-on fs-24"></i> : <i className="bi bi-toggle-off fs-24"></i>}
                        </span>
                      </label>
                    </div>
                  </div>
                </div>)}
                {isVisible && (
                  <>
                    <div className="col-lg-4">
                      <div className="form-group mb-4">
                        <label htmlFor="">Bulk Answers</label>
                        <textarea
                          className="form-control h-25"
                          rows="4"
                          cols="50"
                          value={bulkAnswers}
                          onChange={(e) => setBulkAnswers(e.target.value)}
                        ></textarea>
                      </div>
                    </div>
                    <div className="col-lg-2 align-self-center">
                      <i class="bi bi-node-plus fs-28 " onClick={() => addBulkAnswers()}></i>
                    </div>
                  </>
                )}
                <div className="row">
                  {/* <div className="col-lg-2 align-self-center">
                    <i class="bi bi-plus-circle-dotted fs-28 " onClick={addAnswerSet}></i>
                    {/* <button type="button" className="btn btn-success px-4" onClick={addAnswerSet}>
                      Add
                    </button>
                  </div> */}

                  {questionTypeId == 15 || questionTypeId == 16 ? "" : renderAnswerSets()}
                </div>

                <div className={`d-flex ${questionTypeId == 15 || questionTypeId == 16 ? "justify-content-end" : "justify-content-between"}`}>
                  {questionTypeId == 15 || questionTypeId == 16 ? "" : (<div className="button_group">
                    {/* <button type="button" className="btn bg-danger-subtle text-danger" onClick={() => handleClear()}>

                      Clear Values
                    </button>  */}
                    <button type="button" className="btn btn-success ms-2 px-2" onClick={() => addAnswerSet()}>
                      Add More Answers
                    </button>
                  </div>)}
                  <div className="button_group">
                    <button type="button" className="btn btn-success px-4" onClick={() => handleSubmit()}>
                      Update
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EditQuestions;
